export function applyCountryAndCurrency(store) {
  // Валюта для Норвегии
  if (window.currency_name) {
    if (window.country === 'NO') {
      window.currency_name = 'NOK'
    }
    store.commit('firstSet', { currency: window.currency_name })
  }

  // Устанавливаем страну
  if (window.country) {
    store.commit('firstSet', { country: window.country })
  }

  // Авторизация (true/false)
  store.commit('firstSet', { authed: window.authed || false })
}
